import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import * as Yup from "yup";

/* Redux Actions */
import { Creators as UserActions } from "../../../store/ducks/user";
import { Creators as AppActions } from "../../../store/ducks/app";

import { Formik } from "formik";
import { Row, Col, Input, Spin, notification } from "antd";
import { Container, Footer, CustomDivider, CustomInput } from "./styles";

// Components
import ButtonStandard from "../../utils/button";
import IconCheck from "../../utils/icons/check/white";
import ReCAPTCHA from "react-google-recaptcha";

// Services
import {
  changePassword,
  validateCode,
  verifyExistsUserByEmail,
} from "../../../services/changePasswordService";

class DrawerChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formProfile: {
        password: "",
      },
      isLoading: false,
      confirmPassword: "",
      isCodeValidated: false,
      code: "",
      emailValidate: "",
      redirect: false,
      authorized: true,
      // captchaKey: process.env.REACT_APP_RECAPTCHA_KEY,
      // captchaActive: process.env.REACT_APP_RECAPTCHA_ACTIVATE,
    };
    this.handleChangeValidate = this.handleChangeValidate.bind(this);
  }

  closeDrawer = () => {
    const { userActions } = this.props;
    userActions.hideDrawerChangePassword();
  };

  handleResendCode = async () => {
    const { emailValidate } = this.state;
    this.setState({
      isLoading: true,
      code: null,
      isCodeValidated: false,
    });
    const { translation } = this.props.app;
    try {
      await verifyExistsUserByEmail(emailValidate);
      notification.success({
        message: translation.changePassword.drawer.messages.codeSent,
      });
      this.setState({
        isLoading: false,
      });
    } catch (e) {
      this.setState({
        isLoading: false,
      });
      if (e.response?.status === 409) {
        notification.error({
          message: translation.changePassword.drawer.messages.emailAlreadyRegistered,
        });
      } else if (
        e.response?.status === 500 &&
        e.response?.data.results.description.includes(
          "query did not return a unique result"
        )
      ) {
        notification.error({
          message: translation.changePassword.drawer.messages.emailAlreadyRegistered,
        });
      } else {
        notification.error({
          message: translation.changePassword.drawer.messages.internalError,
        });
      }
    }
  };

  handleChangeValidate(event) {
    this.setState({ code: event.target.value });
  }

  handleValidateCode = async () => {
    const { emailValidate, code } = this.state;
    const obj = {
      email: emailValidate,
      codeValidate: code,
    };
    const { translation } = this.props.app;
    try {
      await validateCode(obj);
      notification.success({ message: translation.changePassword.drawer.messages.codeVerified });
      this.setState({ isCodeValidated: true });
    } catch {
      notification.error({ message: translation.changePassword.drawer.messages.codeInvalid });
    }
  };

  handleDrawerVisible = async (visible) => {
    if (visible) {
      const { formData } = this.props;
      this.setState({
        emailValidate: formData.email,
        id: formData.id,
      });
    }
  };

  handleSubmitModalForm = async (
    values,
    { setSubmitting, setErrors, setStatus, resetForm }
  ) => {
    try {
      this.setState({
        isLoading: true,
      });
      const { authorized } = this.state;
      const { userActions } = this.props;
      if (authorized) {
        const { translation } = this.props.app;
        await changePassword(this.state.id, values);
        notification.success({ message: translation.changePassword.drawer.messages.passwordChanged });
        userActions.hideDrawerChangePassword();
        this.setState({
          redirect: true,
          isLoading: false,
        });
      } else {
        const { translation } = this.props.app;
        this.setState({
          isLoading: false,
        });
        notification.error({ message: translation.changePassword.drawer.messages.notRobot });
      }
    } catch (e) {
      const { translation } = this.props.app;
      if (
        e !== undefined &&
        e !== null &&
        e.toString().indexOf("Request failed with status code 409") > -1
      ) {
        notification.error({ message: translation.changePassword.drawer.messages.passwordUsedBefore });
      } else {
        notification.error({ message: translation.changePassword.drawer.messages.errorResettingPassword });
      }
      this.setState({
        isLoading: false,
      });
    }
  };

  handleCaptcha = () => {
    this.setState({
      authorized: true,
    });
  };

  render() {
    const {
      app: { translation },
      user: { drawerVisibleChangePassword },
    } = this.props;

    const {
      isLoading,
      formProfile,
      isCodeValidated,
      redirect,
      // captchaActive,
      // captchaKey,
    } = this.state;

    const validationSchema = Yup.object().shape({
      password: Yup.string().required(),
      confirmPassword: Yup.string().oneOf(
        [Yup.ref("password"), null],
        "Passwords must match"
      ),
    });

    if (redirect) {
      return (
        <Redirect
          to={{
            pathname: "/",
          }}
        />
      );
    }

    return (
      <Container
        title={translation.changePassword.drawer.title}
        width={425}
        onClose={this.closeDrawer}
        maskClosable={false}
        visible={drawerVisibleChangePassword}
        afterVisibleChange={this.handleDrawerVisible}
      >
        <Spin spinning={isLoading}>
          <div className="drawerFormCustom">
            <Row type="flex">
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <span style={{ fontSize: "14px", color: "#000" }}>
                  {translation.changePassword.drawer.codeInstructions}
                </span>
              </Col>
            </Row>
            <Row type="flex" style={{ marginTop: "13px" }} align="middle">
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Row>
                  <CustomInput
                    className="input-custom"
                    placeholder={translation.changePassword.drawer.codeInputPlaceholder}
                    value={this.state.code}
                    name="code"
                    onChange={this.handleChangeValidate}
                  />
                </Row>
              </Col>
            </Row>

            <Row
              type="flex"
              style={{ marginTop: "13px", justifyContent: "space-between" }}
              align="middle"
            >
              <button
                type="button"
                className="resend"
                onClick={this.handleResendCode}
              >
                <strong>{translation.changePassword.drawer.resendCode}</strong>
              </button>

              <ButtonStandard
                className="verify"
                buttonType="type1"
                background={isCodeValidated ? "#30b142" : "#684e94"}
                type="submit"
                onClick={() => this.handleValidateCode()}
                size="s"
              >
                {isCodeValidated ? <IconCheck /> : null}
                {isCodeValidated ? translation.changePassword.drawer.verified : translation.changePassword.drawer.validate}
              </ButtonStandard>
            </Row>
          </div>
          <Formik
            enableReinitialize={true}
            initialValues={formProfile}
            initialErrors={{}}
            onSubmit={this.handleSubmitModalForm}
            validationSchema={validationSchema}
            render={(props) => (
              <form onSubmit={props.handleSubmit} autoComplete="off">
                <div className="drawerForm">
                  <div className={isCodeValidated ? "" : "hide"}>
                    <CustomDivider dashed />
                    <Row type="flex">
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <span style={{ fontSize: "14px", color: "#000" }}>
                          {translation.changePassword.drawer.definePassword}
                        </span>
                      </Col>
                    </Row>

                    {/* Input password */}
                    <Row
                      type="flex"
                      style={{ marginTop: "13px" }}
                      align="middle"
                    >
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Row>
                          <label
                            className={
                              props.errors.password && props.submitCount > 0
                                ? "error"
                                : ""
                            }
                          >
                            {translation.changePassword.drawer.newPassword}
                          </label>
                        </Row>
                        <Row>
                          <Input
                            type="password"
                            autoComplete="chrome-off"
                            placeholder={translation.defaultPlaceholder}
                            value={props.values.password}
                            name="password"
                            onChange={(e) => {
                              props.setFieldValue("password", e.target.value);
                            }}
                          />
                        </Row>
                      </Col>
                    </Row>

                    {/* Input confirm password */}
                    <Row
                      type="flex"
                      style={{ marginTop: "13px" }}
                      align="middle"
                    >
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Row>
                          <label
                            className={
                              props.errors.confirmPassword &&
                              props.submitCount > 0
                                ? "error"
                                : ""
                            }
                          >
                            {translation.changePassword.drawer.confirmNewPassword}
                          </label>
                        </Row>
                        <Row>
                          <Input
                            type="password"
                            autoComplete="chrome-off"
                            placeholder={translation.defaultPlaceholder}
                            value={props.values.confirmPassword}
                            name="confirmPassword"
                            onChange={(e) => {
                              props.setFieldValue(
                                "confirmPassword",
                                e.target.value
                              );
                            }}
                          />
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </div>
                {/* Footer */}
                <Footer>
                  <Row type="flex" justify="space-between">
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="selectDiv"
                    />

                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="buttonsDiv"
                    >
                      <ButtonStandard
                        type="button"
                        buttonType="type7"
                        onClick={this.closeDrawer}
                      >
                        {translation.buttons.cancel}
                      </ButtonStandard>

                      <ButtonStandard buttonType="type6" type="submit">
                        {translation.buttons.save}
                      </ButtonStandard>
                    </Col>
                  </Row>
                </Footer>
              </form>
            )}
          />
        </Spin>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  app: state.app,
});

const mapDispatchToProps = (dispatch) => ({
  userActions: bindActionCreators(UserActions, dispatch),
  appActions: bindActionCreators(AppActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DrawerChangePassword);
